import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=14c289e1&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VForm,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c289e1')) {
      api.createRecord('14c289e1', component.options)
    } else {
      api.reload('14c289e1', component.options)
    }
    module.hot.accept("./NotificationsSettings.vue?vue&type=template&id=14c289e1&", function () {
      api.rerender('14c289e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotificationsSettings.vue"
export default component.exports